export class Order {
	public Id: number;
	public OrderStatusId: number;
	public SupplierId: number;
	public OrderSupplierId: number;
	public CreatedOnDateId: number;
	public CreatedByUderId: number;
	public ReceivingLocation: string;
	public OrderOrderId: number;
	constructor(status: number, supplierId: number, receivingLocation: string) {
		this.OrderStatusId = status;
		this.SupplierId = supplierId;
		this.ReceivingLocation = receivingLocation;
	}
}
